<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="detailmodel1 clearfix">
        <div class="leftcon">
          <h2 class="title">{{ detail.title }}</h2>
          <div class="imgtxtbox clearfix">
            <div class="imgbox fl">
              <div class="imgboxinner">
                <i class="icon-scale1"></i>
                <img class="imgtop" preview="0" :src="getImage(detail.image)" alt="">
              </div>
              <div class="labelbox">
                <el-button size="small" round v-show="detail.label !== undefined && detail.label !== ''">{{ detail.label }}</el-button>
              </div>
            </div>
            <div class="txtbox fr">
              <div class="con_detail">
                <p class="icon icon4">
                  <input type="text" :value="getTime(detail.publishTime)" disabled="disabled">
                </p>
                <p class="icon icon6" v-show="detail.communityName !== undefined && detail.communityName !== ''">{{ detail.communityName }}</p>
                <p class="icon icon1" v-show="detail.introduction !== undefined && detail.introduction !== ''">{{ detail.introduction }}</p>
              </div>
            </div>
          </div>
          <div class="contentbox" v-html="detail.content"></div>
          <comment @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        </div>
      </div>
    </div>
    <go-top></go-top>
    <right-sidebar
      :comment-count="commentTotal"
      :comment-gotop="commentOffsettop"
      :comment-show="isCommentshow"
      :title="detail.name"
      :image="getImage(detail.image)"
      :url="this.$route.fullPath"
      ref="rightSidebar"></right-sidebar>
  </div>
</template>

<script>
import crumbs from '@/components/crumbs/index'
import { timeFormat } from '@/utils/validate'
import { activitystyledetail } from '@/api/volunteer/index'
import goTop from '@/components/gotop/index'
import RightSidebar from '@/components/rightsidebar/index'
import Comment from '@/components/comment/index'
export default {
  name: 'activitystyledetail',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    goTop,
    RightSidebar,
    Comment
  },
  data () {
    return {
      detail: '',
      noData: false,
      recommend: [],
      commentTotal: '',
      commentOffsettop: '',
      isCommentshow: true // 是否显示评论
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    getTime (val) {
      return timeFormat(val, 'yymmddhhmm')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getDetail () {
      activitystyledetail(this.$route.query.id).then(res => {
        if (res.data.status === 200) {
          this.detail = res.data.data
          // this.recommend = res.data.data.recommendList
          // if (this.recommend.length === 0) this.noData = true
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detailmodel1{
  .leftcon{
    width: 100%;
    .imgtxtbox{
      .imgbox{
        width: 32%;
      }
      .txtbox{
        width: 66%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/vactivitystyledetail.vue